import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { isEmpty, get } from "lodash";
import { Form, Row, Col, Modal, Button } from "react-bootstrap";
import {
  ManageCompanyLayout,
  CsplTable as Table,
  AddButton,
  InnerLayoutHeaderTabs,
  DeleteWarning,
  FieldTextarea,
} from "../../components";
import { useRouterParams, useDeepEffect } from "../../abstracts";
import {
  manageCompanyStore,
  saveCompanyDetails,
  setManageCompanyLocalCache,
  setManageCompanyToastInfo,
} from "../../contexts";
import {
  MANAGE_COMPANY_ROUTES,
  getAdvancedPathWithParam,
  usDateFormat,
  FLOW_TYPES,
  ROUTES,
} from "../../utils";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import {
  faTimes,
  faTrashAlt,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Field, Formik } from "formik";
const columns = [
  {
    label: " ",
    className: "column-sno",
    columnName: "sno",
  },
  {
    label: "Pay date",
    className: "column-pay-date",
    columnName: "payDate",
    link: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_MANAGE_PAYDATES,
  },
  {
    label: "Pay period begin date",
    className: "column-pay-period-begin-date",
    columnName: "beginDate",
  },
  {
    label: "Pay period end date",
    className: "column-pay-period-end-date",
    columnName: "endDate",
  },
  {
    label: "Pay period status",
    className: "column-pay-period-status",
    columnName: "payPeriodStatus",
  },
  {
    label: "Suppress late payroll notifications?",
    className: "column-notification-switch",
    columnName: "notificationSwitch",
  },
];

const PayrollCalendarPayDatesContainer = (props) => {
  const { state, dispatch } = useContext(manageCompanyStore);
  const [isFuturePayDateChecked, setIsFuturePayDateChecked] = useState(true);
  const [tableColumns, setTableColumns] = useState(columns);
  const [notificationSwitch, setNotificationSwitch] = useState(false);
  const { companyId, flow, frequencyId } = useRouterParams();
  const intFrequencyId = parseInt(frequencyId, 10);
  const apiResponse = get(state, "api", {});
  const isApiLoading = get(apiResponse, "isFetching", false);
  const payrollCalendarListData = get(state, "payrollCalendar", []);
  const formValues = get(payrollCalendarListData, intFrequencyId, {});
  const payPeriods = get(state, "payrollCalendarPayPeriods", []);
  const [isLoadingPayPeriods, setIsLoadingPayPeriods] = useState(false);
  const [filteredPayPeriods, setFilteredPayPeriods] = useState([]);
  const [futurePayPeriods, setFuturePayPeriods] = useState([]);
  const { history } = props;
  const DeleteToastMessage = "You are attempting to delete payroll calendar.";
  const DeleteToastMessageHead = "Delete Payroll Calendar?";
  const [showWarning, setShowWarning] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [switchIndex, setSwitchIndex] = useState(false);
  const [notesModalShow, setNotesModalShow] = useState(false);
  useDeepEffect(() => {
    if (isEmpty(futurePayPeriods)) {
      setFuturePayPeriods(
        payPeriods.filter(({ payDate }) => {
          return new Date(payDate) >= new Date();
        })
      );
    }
    setFilteredPayPeriods(
      payPeriods.filter(({ payDate }) => {
        return isFuturePayDateChecked ? new Date(payDate) >= new Date() : true;
      })
    );
  }, [payPeriods, isFuturePayDateChecked]);

  useDeepEffect(() => {
    if (!state?.settings_managecompany?.isLatePayrollApplicable) {
      setTableColumns(
        tableColumns.filter((x) => x.columnName != "notificationSwitch")
      );
    } else {
      setTableColumns(tableColumns);
    }
  }, []);

  const onFuturePayCheckboxClick = () => {
    setIsFuturePayDateChecked(!isFuturePayDateChecked);
  };

  const notificationSwitchClicked = (i) => {
    setFilteredPayPeriods(
      filteredPayPeriods.map((data, index) => {
        if (index === i)
          return { ...data, notificationSwitch: !data.notificationSwitch };
        else return data;
      })
    );
    setNotesModalShow(true);
    setSwitchIndex(i);

    setNotificationSwitch(!notificationSwitch);
  };
  const handleNotesChange = (i, value) => {
    if (value.length < 51) {
      setFilteredPayPeriods(
        filteredPayPeriods.map((data, index) => {
          if (index === i) {
            return { ...data, notificationNotes: value };
          } else return data;
        })
      );
    }
  };
  const addPayDatesClick = () => {
    const payPeriodId = payPeriods.length;
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_MANAGE_PAYDATES,
        pathParam: [FLOW_TYPES.ADD, companyId, frequencyId, payPeriodId],
      })
    );
  };

  const menuList = [
    {
      label: "SETTINGS",
      path: getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_SETTINGS,
        pathParam: [flow, companyId, frequencyId],
      }),
    },
    {
      label: "PAYDATES",
      path: getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
        pathParam: [flow, companyId, frequencyId],
      }),
      selected: true,
    },
  ];
  const handleConfirmClick = () => {
    setShowWarning(false);
    const allowDelete = payrollCalendarListData?.[0]?.payPeriods?.some(
      (x) => x.payPeriodStatus === 2
    );
    if (allowDelete) {
      setShowPopup(true);
    } else {
      saveCompanyDetails(
        {
          payrollCalendars: payrollCalendarListData.filter(
            ({ id }, index) => index !== intFrequencyId
          ),
        },
        dispatch,
        state
      ).then(() => {
        dispatch(
          setManageCompanyToastInfo({
            showToast: true,
            toastMessage: `Data deleted successfully`,
          })
        );
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR,
            pathParam: [flow, companyId],
          })
        );
      });
    }
  };
  const onDeleteClick = () => {
    setShowWarning(true);
  };

  const handleCancelClick = () => {
    setShowWarning(false);
  };
  const handleClose = () => {
    setShowPopup(false);
  };
  const handleNotesModalClose = () => {
    setNotesModalShow(false);
  };

  const getDataForSave = () => {
    //payPeriods=filteredPayPeriods
    var finalData = payPeriods.map(
      (x) => filteredPayPeriods.find((y) => y.payDate === x.payDate) || x
    );
    return payrollCalendarListData.map((item, index) => {
      if (index === intFrequencyId) {
        return { ...item, payPeriods: finalData };
        //return { ...item, payPeriods: payPeriods };
      }
      return {
        ...item,
      };
    });
  };

  const onSavePayDates = () => {
    saveCompanyDetails(
      {
        payrollCalendars: getDataForSave(),
      },
      dispatch,
      state
    ).then(() => {
      history.push(
        getAdvancedPathWithParam({
          path: MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR,
          pathParam: [FLOW_TYPES.EDIT, companyId],
        })
      );
      dispatch(
        setManageCompanyToastInfo({
          showToast: true,
          toastMessage: "Data saved successfully",
        })
      );
    });
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      link: getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR,
        pathParam: [FLOW_TYPES.EDIT, companyId],
      }),
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE],
      onClick: onSavePayDates,
    },
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      link: getAdvancedPathWithParam({
        path: MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR,
        pathParam: [flow, companyId],
      }),
    },
    {
      label: "Edit",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
            pathParam: [FLOW_TYPES.SAVE, companyId, frequencyId],
          })
        ),
    },
    {
      label: "Delete",
      variant: "danger",
      type: "button",
      flow: [FLOW_TYPES.EDIT],
      onClick: onDeleteClick,
    },

    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTimes,
    //   link: getAdvancedPathWithParam({
    //     path: MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR,
    //     pathParam: [flow, companyId],
    //   }),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faPencilAlt,
    //   onClick: () =>
    //     history.push(
    //       getAdvancedPathWithParam({
    //         path: MANAGE_COMPANY_ROUTES.PAYROLL_CALENDAR_PAYDATES,
    //         pathParam: [FLOW_TYPES.SAVE, companyId, frequencyId],
    //       })
    //     ),
    // },
    // {
    //   label: "",
    //   variant: "link",
    //   type: "button",
    //   flow: [FLOW_TYPES.EDIT],
    //   icon: faTrashAlt,
    //   onClick: onDeleteClick,
    // },
  ];
  // const buttons = [
  //   {
  //     label: "Cancel",
  //     variant: "secondary",
  //     type: "button",
  //     flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE, FLOW_TYPES.EDIT],
  //     link: getAdvancedPathWithParam({
  //       path: MANAGE_COMPANY_ROUTES.MANAGE_PAYROLL_CALENDAR,
  //       pathParam: [flow, companyId],
  //     }),
  //   },
  //   {
  //     label: "Save",
  //     variant: "primary",
  //     type: "submit",
  //     flow: [FLOW_TYPES.ADD, FLOW_TYPES.SAVE, FLOW_TYPES.EDIT],
  //     onClick: onSavePayDates,
  //   },
  // ];
  return (
    <ManageCompanyLayout
      buttons={buttons}
      tabs={<InnerLayoutHeaderTabs menuList={menuList} />}
      pageFlow={flow}
    >
      <Row>
        <Col>
          <div className="d-flex align-items-center justify-content-between mb-4 pay-dates-details">
            <div>
              <Form.Check
                custom
                id="isFuturePaydates"
                name="isFuturePaydates"
                type="checkbox"
                label="Show only future pay dates"
                onChange={onFuturePayCheckboxClick}
                checked={isFuturePayDateChecked}
              />
            </div>
            <div>Total pay dates: {payPeriods.length}</div>
            <div>Remaining pay dates: {futurePayPeriods.length}</div>
            {flow == "save" && (
              <div>
                <AddButton
                  menu="company"
                  subMenu="managePayrollCalendar"
                  onAddClick={addPayDatesClick}
                />
              </div>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table isLoading={isLoadingPayPeriods}>
            <Table.Thead>
              <Table.Tr>
                {tableColumns.map((item, index) => {
                  return (
                    <Table.Th key={index} className={item.className}>
                      {item.label}
                    </Table.Th>
                  );
                })}
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody
              isLoading={isApiLoading}
              totalRecords={filteredPayPeriods?.length}
            >
              {filteredPayPeriods.map((payrollFrequency, index) => {
                return (
                  <Table.Tr key={index}>
                    {tableColumns.map((item, cellIndex) => {
                      return (
                        <Table.Td key={cellIndex} className={item.className}>
                          {!isEmpty(item.link) ? (
                            <Link
                              to={getAdvancedPathWithParam({
                                path: item.link,
                                pathParam: [
                                  FLOW_TYPES.EDIT,
                                  companyId,
                                  frequencyId,
                                  payrollFrequency.id,
                                  //payPeriods.length - futurePayPeriods.length,
                                  0,
                                  isFuturePayDateChecked === true ? 1 : 0,
                                ],
                              })}
                              onClick={() => {
                                dispatch(
                                  setManageCompanyLocalCache({
                                    model: "payrollCalendarPayPeriods",
                                    data:
                                      payPeriods.map(
                                        (x) =>
                                          filteredPayPeriods.find(
                                            (y) => y.payDate === x.payDate
                                          ) || x
                                      ) || [],
                                  })
                                );
                                dispatch(
                                  setManageCompanyLocalCache({
                                    model: "prevFlow",
                                    data: flow
                                  })
                                );
                              }}
                            >
                              {usDateFormat(payrollFrequency[item.columnName])}
                            </Link>
                          ) : item.columnName === "sno" ? (
                            index + 1
                          ) : item.columnName === "payPeriodStatus" ? (
                            payrollFrequency[item.columnName] == 2 ? (
                              "Applied"
                            ) : (
                              " - "
                            )
                          ) : item.columnName === "notificationSwitch" &&
                            state.settings_managecompany
                              .isLatePayrollApplicable ? (
                            <Form.Check
                              type="switch"
                              autoFocus="off"
                              id={index + 1}
                              disabled={flow == "edit" ? true : false}
                              name={"notificationSwitch"}
                              checked={payrollFrequency.notificationSwitch}
                              onClick={() => {
                                notificationSwitchClicked(index);
                              }}
                            />
                          ) : (
                            usDateFormat(payrollFrequency[item.columnName])
                          )}
                        </Table.Td>
                      );
                    })}
                  </Table.Tr>
                );
              })}
            </Table.Tbody>
          </Table>
        </Col>
      </Row>
      <DeleteWarning
        DeleteToastMessageHead={DeleteToastMessageHead}
        DeleteToastMessage={DeleteToastMessage}
        showModal={showWarning}
        handleConfirmClick={handleConfirmClick}
        handleCancelClick={handleCancelClick}
      />
      <Modal show={showPopup} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <p>
                {
                  "CM075 : Payroll Calendar can’t be deleted, as there are census/payroll record(s) associated with it"
                }
              </p>
              <br />
              <Button className="cancel-btn" onClick={handleClose}>
                Ok
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={notesModalShow} onHide={handleNotesModalClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleNotesModalClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <p>
                Notes <span className="ft-12 fw-300">(optional)</span>
              </p>

              <input
                size="smd"
                //isRequired
                placeholder=""
                style={{ marginBottom: "15px", borderRadius: "5px" }}
                //label={"Notes"}
                name={"notificationNotes"}
                type="text"
                value={filteredPayPeriods[switchIndex]?.notificationNotes}
                //disabled={isEdit && !isSave}
                onChange={(value) =>
                  handleNotesChange(switchIndex, value.target.value)
                }
                // component={FieldTextarea}
              />

              <br />
              <Button className="cancel-btn" onClick={handleNotesModalClose}>
                Ok
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </ManageCompanyLayout>
  );
};

export default PayrollCalendarPayDatesContainer;
